import { render, staticRenderFns } from "./BookingUnvisitedList.vue?vue&type=template&id=78f64041"
import script from "./BookingUnvisitedList.vue?vue&type=script&lang=js"
export * from "./BookingUnvisitedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports